export default __webpack_public_path__ + "static/img4-0cce896e8c8603fee0dd1a96a0f424c7.png";